// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","link":"link_link__1XpnJ","href":"link_href__3JBs-","text":"link_text__1mcXl"};